export * from './HighlightedCode';
export { HighlightedCodeWithTabs } from '../HighlightedCodeWithTabs/HighlightedCodeWithTabs';
